import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { ComponentType } from '@/configuration/component/component-types'

export const useGeneralCommentsUploadFileMutation = (generalCommentComponentType: ComponentType) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: { file?: File, commentId: number, generalCommentComponentSid: string}) =>
            hcaClientFactory.generalCommentsApi.uploadGeneralCommentFile(payload.file, payload.commentId),
        onSuccess: async (_response, payload) => {
            if (generalCommentComponentType === ComponentType.Transformer) {
                await queryClient.resetQueries({ queryKey: ['transformers', payload.generalCommentComponentSid, 'generalComments'] })
            } else if (generalCommentComponentType === ComponentType.Generator) {
                await queryClient.resetQueries({ queryKey: ['generators', payload.generalCommentComponentSid, 'generalComments'] })
            }
        },
    })
}
